import type { ArticleContent, ArticleContents } from './types';
import type { Lang } from '../categories';
import en from './en';
import fr from './fr';
import da from './da';
import de from './de';

const contents: ArticleContents = { en, fr, da, de };

export const getArticleContent = (slug: string, lang: Lang): ArticleContent | undefined =>
  contents[lang]?.[slug];

export const getArticleTitle = (slug: string, lang: Lang): string =>
  contents[lang]?.[slug]?.title ?? contents.en[slug]?.title ?? slug;

export const getArticleShort = (slug: string, lang: Lang): string =>
  contents[lang]?.[slug]?.shortDescription ?? contents.en[slug]?.shortDescription ?? '';